module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d8c268c304caec7b98b44bc3675d728a.png";